
export default function Warning({text}) {
    return(
        <div>
            <p className="mt-2 text-sm text-gray"><span className="text-red-500 mr-1">**</span>{text}</p>
        </div>
    )
}